import Accordions from './modules/Accordions'
import Animations from './modules/Animations'
import Menu from './modules/Menu'
import PageTurn from './modules/PageTurn'
// import Sliders from './modules/Sliders'

export default class Main {
  constructor() {
    this.init()
  }

  init() {
    Menu.init()
    Accordions.init()
    PageTurn.init()
    // Sliders.init()

    window.addEventListener('load', () => {
      Animations.init()
    })
  }
}

const main = new Main()
